import { Tabs } from 'antd';
import { AntToggleButton, FormHeader, ModalFormContainer } from 'component/form_component/style';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import React, { useEffect, useState } from 'react';
import SpecificDomainSettings from './settings';
import { AdminTitleWrap } from 'pages/admin_page/style';
import DomainEmailTemplate from './mailTemplate';
import DomainEmailDelivery from './mailDelivery';
import { OverrideGlobalLabel, OverrideGlobalWrap } from './style';
import UserFields from 'pages/user_fields';
import { SweetSweetAlert } from 'component/sweetalert_components';
import {
  getDomainSettingPageDetails,
  getOverrideGlobalStatus,
  getOverrideGlobalStatusforloginUser,
  updateOverrideGlobalStatus,
} from 'redux/slices/settingsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getDomainSettingsMailTemplate } from 'redux/slices/mailTemplateSlice';
import {
  getDomainEmailDelivery,
  getDomainEmailDeliverySettings,
  getDomainGmailDelivery,
  getDomainMicrosoftMailDelivery,
} from 'redux/slices/mailDeliverySlice';
import ExportAttribute from './exportAttribute';

export default function DomainSettings({ record }) {
  const [apiLoading, setApiLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState('1');
  const { overrideGlobalStatus } = useSelector((state) => state.settings);
  const [overRideGlobal, setOverRideGlobal] = useState({
    template: false,
    emailDelivery: false,
    settings: false,
    domainId: record.id,
  });
  const dispatch = useDispatch();
  const getCheckedValue = () => {
    switch (currentTab) {
      case '1':
        return overRideGlobal.settings;
      case '2':
        return overRideGlobal.emailDelivery;
      case '3':
        return overRideGlobal.template;
      default:
        return false;
    }
  };
  const getDataFunction = async () => {
    switch (currentTab) {
      case '1':
        await dispatch(getDomainSettingPageDetails(record.id));
        if (record.id === Number(localStorage.getItem('domainId'))) {
          await dispatch(getOverrideGlobalStatusforloginUser());
        }
        break;
      case '2':
        await dispatch(getDomainEmailDeliverySettings(record.id));
        await dispatch(getDomainEmailDelivery(record.id));
        await dispatch(getDomainGmailDelivery(record.id));
        await dispatch(getDomainMicrosoftMailDelivery(record.id));
        break;
      case '3':
        await dispatch(getDomainSettingsMailTemplate(record.id));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(getOverrideGlobalStatus(record.id));
  }, []);

  useEffect(() => {
    setOverRideGlobal(
      overrideGlobalStatus || {
        template: false,
        emailDelivery: false,
        settings: false,
        domainId: record.id,
      }
    );
  }, [overrideGlobalStatus]);

  const handleOverRideGlobal = async (checked) => {
    let updatedOverRideGlobal = { ...overRideGlobal };

    switch (currentTab) {
      case '1':
        updatedOverRideGlobal.settings = checked;
        break;
      case '2':
        updatedOverRideGlobal.emailDelivery = checked;
        break;
      case '3':
        updatedOverRideGlobal.template = checked;
        break;
      default:
        break;
    }

    try {
      setApiLoading(true);
      const responae = await dispatch(updateOverrideGlobalStatus(updatedOverRideGlobal));
      if (responae.payload && responae.payload.status === 200) {
        setOverRideGlobal(updatedOverRideGlobal);
        await SweetSweetAlert({
          sweetData: checked ? 'Override Global Enabled.' : 'Override Global Disabled.',
          icon: 'success',
          buttonColor: 'green',
        });
        await dispatch(getOverrideGlobalStatus(record.id));
        await getDataFunction();
      } else {
        SweetSweetAlert({ text: responae.payload.data, icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setApiLoading(false);
    }
  };
  const handleTabChange = (key) => {
    setCurrentTab(key);
  };
  const items = [
    {
      key: '1',
      label: 'Settings',
      children: (
        <div>
          <SpecificDomainSettings {...record} />
        </div>
      ),
    },
    {
      key: '2',
      label: 'Email Delivery',
      children: (
        <div>
          <DomainEmailDelivery {...record} />
        </div>
      ),
    },
    {
      key: '3',
      label: 'Email Templates',
      children: (
        <div>
          <DomainEmailTemplate {...record} />
        </div>
      ),
    },
    {
      key: '4',
      label: 'User Fields',
      children: (
        <div>
          <UserFields {...record} />
        </div>
      ),
    },
    {
      key: '5',
      label: 'Export Users',
      children: (
        <div>
          <ExportAttribute {...record} />
        </div>
      ),
    },
  ];
  return (
    <div>
      <ModalFormContainer className='af-modal-container af-domain-settings-modal-container'>
        {apiLoading && <ModalOpenLoader />}
        <AdminTitleWrap className='af-domain-settings-header-wrap'>
          <FormHeader className='af-form-header af-domain-settings-form-header'>
            Settings: {record.domainName}
          </FormHeader>
          {!['4', '5'].includes(currentTab) && (
            <OverrideGlobalWrap className='af-form-header af-domain-settings-overrideGlobal-button-wrap'>
              <OverrideGlobalLabel className='af-form-header af-domain-settings-overrideGlobal-button-label'>
                Override Global:
              </OverrideGlobalLabel>

              <AntToggleButton
                checked={getCheckedValue()}
                onChange={handleOverRideGlobal}
                className='af-superadmin-domain-settings-header-form-form-item-overrideGlobal-toggle'
              />
            </OverrideGlobalWrap>
          )}
        </AdminTitleWrap>

        <Tabs
          className='af-form-tab af-domain-settings-form-tab'
          defaultActiveKey='1'
          items={items}
          tabPosition='top'
          tabBarGutter={20}
          onChange={handleTabChange}
        />
      </ModalFormContainer>
    </div>
  );
}
